import { Tooltip } from 'antd';
import Style from './style';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import i18next from "i18next";

export const ToggledText = ({
  text = '',
  className = '',
}) => {
  if (text) {
    return (
      <Tooltip title={text}>
        <p className={formatClassname([className, !text && 'not-answered'])} style={{
          overflow: 'hidden',
        }}
        >
          {text}
        </p>
      </Tooltip>
    );
  }

  return (
    <p className={formatClassname([className, !text && 'not-answered'])} style={{
      overflow: 'hidden',
    }}
    >
      {i18next.t('Not Answered')}
    </p>
  );
}

const Comment = ({
  comment = null,
  tooltip,
  isCoveredRiskComment = true,
  label = null,
  t = (s) => s,
}) => (
  <Style className={formatClassname([isCoveredRiskComment && 'default-comment'])}>
    {isCoveredRiskComment && (
      <p className="title">{label ? label : t('Details')}</p>
    )}
    <ToggledText
      tooltip={tooltip}
      text={comment}
      t={t}
      className="text"
    />
  </Style>
);

export default Comment;
